import { Theme } from "@material-ui/core/styles";
import COLORS from "../../colors";

const style: any = (theme: Theme): any => ({
	sideBarContainer: {
		padding: "32px 40px 0px 40px",
		height: "calc(100% - 72px)",
		overflow: "auto",
		transition: "transform 250ms ease, width 250ms ease, inherit !important",
		
	},
	sidebarHeader: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		marginBottom: 20
	},
	sideBarTitle: {
		fontSize: 20,
		fontWeight: theme.typography.fontWeightBold
	},

	drawerMenu: {
		transition: theme.transitions.create("margin", {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
		marginRight: 0,
	},
	filterButton: {
		border: "1px solid rgb(208, 213, 218)",
		backgroundColor: COLORS.WHITE,
		color: COLORS.DARK_GRAY,
		padding: "7px 12px 8px 12px",
		fontWeight: theme.typography.fontWeightMedium,
		"&:hover": {
			border: "1px solid #868e96",
			backgroundColor: COLORS.WHITE,
		}
	},
	filterDot: {
		fontSize: "2.2rem",
		margin: "0 0.2rem",
		paddingBottom: "0.1rem"
	},
	actionContainer: {
		position: "absolute" as const,
		bottom: 0,
		height: 72,
		padding: "0px 40px",
		display: "flex",
		alignItems: "center" as const,
		justifyContent: "flex-end",
		backgroundColor: COLORS.WHITE
	},
	resetBtn: {
		position: "absolute" as const,
		left: 34,
		bottom: 31,
		top: 20,
		width: "39px",
		height: "21px",
		paddingLeft: 0,
		margin: "8px 244px 7px 0",
		fontSize: "14px",
		fontWeight: "500",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "1.5",
		letterSpacing: "normal",
		color: "#005fbe"
	}
});

export default style;